import React from 'react';
import Repeater from '../../../system/fields/Repeater';
import Guide from './Guide';
import { Button } from 'reactstrap';
import {
  Field,
  reduxForm,
  stopSubmit,
  getFormValues,
  FieldArray,
} from "redux-form";
import { connect } from "react-redux";


class Guides extends React.Component {
  remove(index) {
    const result = window.confirm(
      'Are you sure you want to remove this guide item?'
    );
    if (result) {
      this.props.fields.remove(index);
    }
  }

  render() {
    const { state, props } = this;
    const { fields } = props;

    return (
      <div className='repeater-container'>
        {fields.map((leg, index) => (
          <Repeater key={index}>
            <div className='toolbar'>
              {index + 1 !== fields.length || index !== 0 ? (
                <div className='group'>
                  <span>Move</span>
                  {index + 1 !== fields.length && (
                    <i
                      className='fas fa-angle-down'
                      onClick={() => fields.move(index, index + 1)}
                    />
                  )}
                  {index !== 0 && (
                    <i
                      className='fas fa-angle-up'
                      onClick={() => fields.move(index, index - 1)}
                    />
                  )}
                </div>
              ) : (
                ''
              )}
              <i
                className='far fa-trash-alt'
                onClick={() => this.remove(index)}
              />
            </div>

            <Guide leg={leg} index={index} formValues={props.formValues} CLIndex={props.CLIndex} OIndex={props.OIndex} />
          </Repeater>
        ))}

        <div className='add-button bottom'>
          <Button type='button' onClick={() => fields.push({})}>
            Add Item
          </Button>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    formValues: getFormValues("DealForm")(state),
  };
};

export default connect(mapStateToProps)(Guides);


// WEBPACK FOOTER //
// ./src/containers/Deals/components/Guides.jsx